import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';

import { Site } from '@classes/site';
import { SitesService } from '@services/sites.service';
import { UsersService } from '@services/users.service';

export type OrderCreateMode = 'transport' | 'transmission';

export interface OrderCreateModeAccess {
  hasTransportSites: boolean;
  hasTransmissionSites: boolean;
}

@Injectable({
  providedIn: 'root'
})
export class OrderCreateModeService {
  constructor(
    private usersSrv: UsersService,
    private sitesSrv: SitesService
  ) { }

  getAccessibleSites(): Observable<Site[]> {
    return this.sitesSrv.getList()
  }

  getAccess(): Observable<OrderCreateModeAccess> {
    return this.getAccessibleSites().pipe(
      map(sites => ({
        hasTransportSites: this.hasSitesForMode(sites, 'transport'),
        hasTransmissionSites: this.hasSitesForMode(sites, 'transmission')
      }))
    );
  }

  hasSitesForMode(sites: Site[], mode: OrderCreateMode): boolean {
    return this.filterSitesForMode(sites, mode).length > 0;
  }

  filterSitesForMode(sites: Site[], mode: OrderCreateMode): Site[] {
    sites = sites || [];

    return sites.filter(site => mode === 'transmission'
      ? site.transmissionOnly === true
      : site.transmissionOnly !== true
    );
  }
}